export default [
  {
    path: '/admin/functions',
    name: 'admin_functions',
    component: () => import('./FunctionsAdmin.vue'),
    meta: {
      name: 'Admin - Funções',
    },
  },
]
